import React, { useState, useEffect, ReactNode } from 'react';
import { Box, Fade, SxProps } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';

interface DpCenefaSliderProps {
	children: ReactNode[];
	interval?: number;
	sx?: SxProps;
}

export const DpCenefaSlider: React.FC<DpCenefaSliderProps> = ({
	children,
	interval = 4000,
	sx,
}) => {
	const [index, setIndex] = useState(0);
	const cleanChildren = React.Children.toArray(children).filter((child) =>
		React.isValidElement(child)
	);

	useEffect(() => {
		const timer = setInterval(() => {
			setIndex((prev) => (prev + 1) % cleanChildren.length);
		}, interval);
		return () => clearInterval(timer);
	}, [cleanChildren.length, interval]);

	return (
		<Box
			sx={combineSX([
				{
					width: '100%',
					backgroundColor: '#2b2b2b',
					textAlign: 'center',
					padding: '8px',
					color: 'white',
					fontSize: '13px',
					overflow: 'hidden',
				},
				...(Array.isArray(sx) ? sx : [sx]),
			])}
		>
			<Fade in key={index} timeout={800}>
				<Box sx={{ display: 'inline-block' }}>{cleanChildren[index]}</Box>
			</Fade>
		</Box>
	);
};

interface DpCenefaItemProps {
	children: ReactNode;
	href?: string;
	sx?: SxProps;
}

export const DpCenefaItem: React.FC<DpCenefaItemProps> = ({ children, sx, ...props }) => {
	return (
		<Linkable
			{...props}
			sx={combineSX([
				{ fontWeight: 500, display: 'inline-block', color: 'white', fontSize: '13px' },
				...(Array.isArray(sx) ? sx : [sx]),
			])}
		>
			{children}
		</Linkable>
	);
};
